<template>
    <section>
      <h3 class="centered-text">Please Enter Your Delivery Information</h3>
      <img v-bind:src="banner_image" class="banner-image" />
      <p class="customer-info-form centered-text delivery-info">You don't need to be home for delivery!</p>
      <p class="customer-info-form centered-text delivery-info">Simply Mark an “X” on a clearly visible & accessible 4’x4’ area of your driveway where you would like the bag placed. A general rule of thumb is ‘if you can ROUTINELY drive your car to the bag location, we <strong>may</strong> be able to place the bag there’.</p>
      <p class="customer-info-form centered-text note">Note: Our delivery units require clear access of a minimum of 10 feet wide and 16 feet high. We cannot go through gates or lift over shrubs or fences. Remember the air conditioner at the side of your house and low hanging wires too.</p>

      <p class="centered-text">*All Fields Required</p>

      <form class="customer-info-form">
        <ValidationObserver ref="observer" v-slot="{ invalid }"  @submit.prevent="submit()">
          <div class="flex-row">
            <ValidationProvider class="validated-input--container" rules="required" v-slot="{ errors, classes }" name="First Name">
              <input type="text" name="firstName" placeholder="First Name" v-model="customer.firstName" :class="classes">
              <span class="input--inline-error" v-if="errors.length">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider class="validated-input--container" rules="required" v-slot="{ errors, classes }" name="Last Name">
              <input type="text" name="lastName" placeholder="Last Name" v-model="customer.lastName" :class="classes">
              <span class="input--inline-error" v-if="errors.length">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="flex-row">
            <ValidationProvider class="validated-input--container" rules="required" v-slot="{ errors, classes }"  name="Street">
              <input type="text" name="address" placeholder="Address" v-model="customer.address.street" :class="classes">
              <span class="input--inline-error" v-if="errors.length">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider class="validated-input--container" rules="required" v-slot="{ errors, classes }" name="City">
              <input type="text" name="city" placeholder="City" v-model="customer.address.city" :class="classes">
              <span class="input--inline-error" v-if="errors.length">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <a @click='resetPostal'>Change</a>
          <div class="flex-row">
            <ValidationProvider class="validated-input--container" v-slot="{ classes }">
              <input type="text" name="postal" :value="customer.address.postal" :class="classes" disabled>
            </ValidationProvider>

            <ValidationProvider class="validated-input--container" rules="required" v-slot="{ errors, classes }" name="Region">
              <div class="select-container">
                <select v-model="customer.address.region">
                  <option :value="null" disabled>Select Region</option>
                  <option v-for="region in regionOptions" :value="region.code" :key="region.id" >
                    {{ region.name }}
                  </option>
                </select>
              </div>
              <span class="input--inline-error" v-if="errors.length">{{ errors[0] }}</span>
            </ValidationProvider>

          </div>
          <div class="flex-row">
            <ValidationProvider class="validated-input--container" rules="required|phone" v-slot="{ errors, classes }" name="Phone">
              <input type="text" name="phone" placeholder="Phone Number" v-model="customer.phone" :class="classes">
              <span class="input--inline-error" v-if="errors.length">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider class="validated-input--container">
              <input type="number" id="returnsCount" name="returnsCount" v-model="customer.bagReturnsCount" placeholder="# of empty bag returns?">
            </ValidationProvider>
          </div>

          <div class="flex-row">
            <ValidationProvider class="validated-input--container" rules="required" v-slot="{ errors, classes }" name="email" mode="lazy">
              <input type="email" name="email" placeholder="E-mail" v-model="customer.email" :class="classes">
              <span class="input--inline-error" v-if="errors.length">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider class="validated-input--container" rules="required|confirmed:email" v-slot="{ errors, classes }" name="Email Confirmation" vid="emailConfirm" mode="lazy">
              <input type="email" name="emailConfirmation" placeholder="Confirm E-mail" v-model="customer.emailConfirm" :class="classes">
              <span class="input--inline-error" v-if="errors.length">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="flex-row">
            <fieldset>
              <label for="markerLocation">
                Where on your property will the "X" be Marked?
              </label>
              <ValidationProvider class="validated-input--container" rules="required" v-slot="{ errors, classes }" name="Marker Location">
                <input type="text" id="markerLocation" name="markerLocation" placeholder='specify where your "X" will be marked' v-model="customer.address.markerLocation" :class="classes">
                <span class="input--inline-error" v-if="errors.length">{{ errors[0] }}</span>
              </ValidationProvider>
            </fieldset>
          </div>

          <div class="flex-row" style="text-align: center">
            <input type="checkbox" id="offers" name="offers" v-model="customer.emailMe">
            <label for="offers">
              I would like to be kept up to date on gardening tips and BigYellowBag Exclusive offers
            </label>
          </div>

          <div class="flex-row" style="text-align: center">
            <label for="wincode">
              Enter Your Wincode, Loyalty Code, or Promo Code
            </label>
          </div>
          <div class="flex-row" style="text-align: center; flex-direction: column; align-items: center;">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <input type="text" class="wincode-field" name="wincode" v-model="customer.wincode" placeholder="Win/Loyalty/Promo Code" @keyup="discountCodeFieldListner" style="flex: none;">
              <button type="button" @click="checkWincode" class="small-button">Apply</button>
            </div>
            <span class="input--inline-message" style="color: red;" v-if="discountCodeError.length">{{ discountCodeError }}</span>
            <span class="input--inline-message" style="color: black;" v-if="discountCodeMessage.length && !discountCodeError.length">{{ discountCodeMessage }}</span>
          </div>
        </ValidationObserver>
      </form>
    </section>
</template>

<script>
import { mapState } from 'vuex';
import bannerImage from '../../../../assets/images/X-marks-the-spot-photo.jpg';

export default {
  name: 'CustomerInfo',

  data() {
    return {
      wincodeMessage: '',
      banner_image: bannerImage,
    };
  },

  // beforeDestroy() {
  //   this.submitWincodeInfo();
  // },

  computed: {
    ...mapState(['customer']),

    allWincodes() {
      return this.$store.state.wincodes;
    },

    regionOptions() {
      return this.$store.state.regions;
    },

    discountCodeError() {
      return this.$store.state.discountCodeError;
    },

    discountCodeMessage() {
      if(this.$store.state.wincode.discount > 0) {
        return "Congratulations! You will receive a discount of $"+ this.$store.state.wincode.discount.toFixed(2) +" from "+ this.$store.state.wincode.name
      } else {
        // just in case if we need to add different messages for wincode and other codes
        if (this.$store.state.wincode.discount_type === 'WinCode') {
          return "Thank you for adding your wincode"
        }
        return ''
      }
    }
  },

  mounted() {
    // not to mess up anything somewhere
    this.customer.bagReturnsCount = null;
  },

  methods: {
    checkWincode() {
      // const customerWincode = this.customer.wincode.replace(/\s/g, '').toUpperCase();
      //
      // const foundWincode = this.allWincodes.filter((wincode) => {
      //   const matchingWincode = wincode.code.toUpperCase() === customerWincode;
      //   // Check if matching wincode is also active & has a discount greater than 0;
      //   if (matchingWincode && (wincode.discount > 0) && wincode.active) { return true; }
      //   return false;
      // });
      //
      // if (foundWincode[0]) {
      //   this.wincodeMessage = `Congratulations! You will receive a discount of $${foundWincode[0].discount} per bag.`;
      //   return foundWincode[0];
      // }
      //
      // // If no wincode found & wincode was input, add error
      // if (customerWincode.length > 0) {
      //   this.wincodeMessage = 'Thank you for entering your wincode';
      // }
      // return {};
      const customerWincode = this.customer.wincode.replace(/\s/g, '').toUpperCase();

      if (customerWincode.length > 0) {
        this.$store.dispatch('getDiscount', customerWincode);

        // if (this.$store.getters.discountCodeAmounts > 0) {
        //   this.wincodeMessage = `Congratulations! You will receive a discount of $${this.$store.getters.discountCodeAmounts}`;
        // } else {
        //   this.wincodeMessage = 'Thank you for entering your wincode';
        // }
      } else {
        this.$store.commit('setProperties', {
          discountCodeError: '',
          wincode: {code: '', discount: 0, name: ''}});
      }
    },

    discountCodeFieldListner() {
      const customerWincode = this.customer.wincode.replace(/\s/g, '').toUpperCase();

      if (customerWincode.length < 1) {
        this.checkWincode()
      }
    },

    resetPostal() {
      this.$store.commit('setProperties', { postalModal: { showModal: true, postalError: '' } });
    },

    // submitWincodeInfo() {
    //   const validWincode = this.checkWincode();
    //   this.$store.commit('setProperties', { wincode: validWincode });
    // },

    async validate() {
      const isValid = await this.$refs.observer.validate();
      return isValid;
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-info-form {
  max-width: 768px;
  margin: 0 auto;
}

.banner-image {
  max-width: 768px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

a {
  margin: .38em 1em;
  cursor: pointer;
}

input[type="text"],
input[type="number"],
input[type="tel"],
input[type="email"],
select {
  background-color: #F4F4F4;
  font-size: 1.62em;
  border-radius: 0.38em;
  padding: 0.38em;
  border: 1px solid #DBDBDB;
  margin: .38em .62em;
}

.select-container {
  position: relative;

  &::after {
    content: '\25BC';
    position: absolute;
    top: 1.62em;
    right: 1.62em;
    pointer-events: none;
  }
}

label {
  margin: .38em .62em;
  flex: 1;
  width: 100%;
}

.flex-row {
  display: flex;
  justify-content: center;
}

.flex-row fieldset {
  flex: 1;
  margin: 0;
  padding: 0;
  border: none;
}

.flex-row fieldset label {
  margin: .38em 1em;
  display: inline-block;
  height: 2.62em;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.validated-input--container {
  flex: 1;
  width: 100%;
}

.flex-row .validated-input--container input,
.flex-row .validated-input--container select,
.flex-row input,
.flex-row select {
  flex: 1;
  width: calc(100% - 2em);
  box-sizing: initial;
  -webkit-appearance: none;
  appearance: none;
}

input[type="text"].wincode-field {
  max-width: 14em;
}

.input--inline-message,
.input--inline-error {
  font-weight: bold;
  padding: 0 0.62em;
  display: block;
  margin: 0 1em 1em 1em;
}

.input--inline-error {
  color: red;
}

input.invalid {
  border-color: red;
  border-width: 2px;
}

[type="checkbox"] {
  margin: 0.38em 0.62em;
  display: none;

  & + label {
    position: relative;
    padding-left: 38px;
    margin: 1em;
    text-align: left;
    width: calc(100% - 2em);
    box-sizing: border-box;
    max-width: 480px;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 5px;
      width: 22px;
      height: 22px;
      border: 3px solid #009245;
      background-color: white;
    }

    &:after {
      content: '\2713';
      width: 16px;
      height: 16px;
      font-weight: bold;
      line-height: 16px;
      position: absolute;
      top: 11px;
      left: 6px;
      transition: all 0.24s ease;
    }
  }

  &:checked {
    & + label:after {
      opacity: 1;
      transform: scale(1);
    }

    &:active + label:after {
      opacity: 1;
      transform: scale(0.83);
    }
  }

  &:not(:checked) {
    & + label:after {
      opacity: 0;
      transform: scale(0);
    }

    &:active + label:after {
      opacity: 1;
      transform: scale(0.38);
    }
  }
}

.delivery-info {
  font-size: 19px;
  margin-top: 20px;
}

.small-button {
  font-family: inherit;
  font-size: 12px;
  color: black;
  background-color: #FFE52C;
  border-color: #009245;
  box-shadow: none;
  border-radius: 6px;
  font-weight: bold;
  flex: 1;
  margin: 0 .38em;
  text-shadow: none;
  text-transform: uppercase;
  height: 4em;

  &:hover {
    color: black;
  }
}

strong {
  font-size: 21px;
  font-weight: bolder;
}

p.note {
  font-size: 11px;
  margin-top: 20px;
  margin-bottom: 20px;
}

label[for="markerLocation"] {
  margin: 1.38em -2em -1em 1em!important;
}

input[id^="returnsCount"]::-webkit-input-placeholder {
  text-transform: lowercase;
}
input[id^="returnsCount"]::-moz-placeholder {
  text-transform: lowercase;
}
input[id^="returnsCount"]:-ms-input-placeholder {
  text-transform: lowercase;
}
input[id^="returnsCount"]:-moz-placeholder {
  text-transform: lowercase;
}

@media (max-width: 480px) {
  .flex-row {
    flex-direction: column;
  }

  .flex-row fieldset label {
    height: initial;
  }
}

</style>
